(function ($) {
  "use strict";

  if (!$) {
    return;
  }

  const $header = $(".page-header");
  const $toggle = $(".page-header__toggle");
  const $brand = $(".page-header__brand");
  const $nav = $(".page-header__nav");

  if (!$header.length || !$toggle.length) {
    return;
  }

  const headerEl = $header[0];

  function syncPageHeaderOpenState() {
    const isOpen = $header.hasClass("page-header--open");

    $toggle.attr("aria-expanded", isOpen ? "true" : "false");

    const hidden = isOpen ? "false" : "true";
    $brand.attr("aria-hidden", hidden);
    $nav.attr("aria-hidden", hidden);

    $brand.add($nav).each(function () {
      if (isOpen) {
        $(this).removeAttr("inert");
      } else {
        $(this).attr("inert", "");
      }
    });
  }

  function closePageHeader() {
    if (!$header.hasClass("page-header--open")) {
      return;
    }
    $header.removeClass("page-header--open");
    syncPageHeaderOpenState();
  }

  syncPageHeaderOpenState();

  $toggle.on("click", () => {
    if ($header.hasClass("page-header--open")) {
      closePageHeader();
    } else {
      $header.addClass("page-header--open");
      syncPageHeaderOpenState();
    }
  });

  $(document).on("keydown.pageHeader", (e) => {
    if (e.key !== "Escape" && e.key !== "Esc") {
      return;
    }
    if (!$header.hasClass("page-header--open")) {
      return;
    }
    e.preventDefault();
    closePageHeader();
  });

  $(document).on("click.pageHeader", (e) => {
    if (!$header.hasClass("page-header--open")) {
      return;
    }
    if (headerEl.contains(e.target)) {
      return;
    }
    closePageHeader();
  });
})(window.jQuery);
